// extracted by mini-css-extract-plugin
export var actionText = "_rc-4";
export var container = "_rc-0";
export var leftSection = "_rc-1";
export var rightSection = "_rc-2";
export var settingsButton = "_rc-6";
export var settingsIcon = "_rc-7";
export var shortcut = "_rc-5";
export var shortcutGroup = "_rc-3";